(ns minorodata.users.subs
  (:require [clojure.set :as set]
            [clojure.string :as clojure.string]
            [minorodata.utils :refer [contains-value]]
            [re-frame.core :as re-frame]
            [re-posh.core :as re-posh]))

(defn ->set
  [x]
  (cond
    (nil? x)        #{}
    (set? x)        x
    (sequential? x) (into #{} x)
    :else           (conj #{} x)))

(re-frame/reg-sub
 :users.subs/has-permissions?
 (fn [_ [_ required-permissions]]
   (let [user                @(re-posh/subscribe [:user/pull])
         permissions         (->set (:user/permissions user))
         req-permissions-set (->set required-permissions)]
     (or (and (not permissions)
              (not (req-permissions-set :admin/all)))
         (empty? req-permissions-set)
         (and (not (req-permissions-set :superadmin/all))
              (permissions :admin/all))
         (clojure.set/subset? req-permissions-set permissions)))))

(re-frame/reg-sub
 :users.subs/admin?
 (fn []
   [(re-posh/subscribe [:unleash/is-enabled "superadmin-permission"])
    (re-posh/subscribe [:user/pull])])
 (fn [[enabled? {:user/keys [roles]}]]
   (if enabled?
     @(re-posh/subscribe [:users.subs/has-permissions? :admin/all])
     (contains-value roles "admin"))))

(re-frame/reg-sub
 :users.subs/superadmin?
 (fn []
   [(re-posh/subscribe [:unleash/is-enabled "superadmin-permission"])
    (re-posh/subscribe [:user/pull])])
 (fn [[enabled? {:user/keys [roles]}]]
   (if enabled?
     @(re-posh/subscribe [:users.subs/has-permissions? :superadmin/all])
     (contains-value roles "super-admin"))))

(re-frame/reg-sub
 :users.subs/roles
 (fn []
   (let [{:user/keys [cid]} @(re-posh/subscribe [:user/pull])]
     (some->> @(re-posh/subscribe [:client-roles/pull [:client-roles/cid cid]])
              :client-roles/roles
              (sort-by (comp clojure.string/lower-case :role/name))))))

(re-frame/reg-sub
 :users.subs/preferences
 (fn [db]
   (get-in db [:user :preferences])))
